import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a08b756"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Users By Belt Report", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Data range to load:", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<option value=\"4\" data-v-0a08b756> 2 years </option><option value=\"5\" data-v-0a08b756> 2 and a half years </option><option value=\"6\" selected data-v-0a08b756> 3 years </option><option value=\"7\" data-v-0a08b756> 3 and a half years </option><option value=\"8\" data-v-0a08b756> 4 years </option><option value=\"9\" data-v-0a08b756> 4 and a half years </option><option value=\"10\" data-v-0a08b756> 5 years </option>", 7)
const _hoisted_10 = [
  _hoisted_3
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This report shows the belt levels of TLBS students at different time periods. The most recent time period is the only accurate dataset since a record wasn't kept of when students joined and left Business School."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" The past time periods are estimates and only include students that recorded a sales target in that time period (6 months) or if they are currently a member of Business School and recorded at least one sale before that time period. ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("select", {
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dataRangeChanged && _ctx.dataRangeChanged(...args)))
    }, _hoisted_10, 32 /* HYDRATE_EVENTS */),
    (!_ctx.loaded)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, " loading... "))
      : _createCommentVNode("v-if", true),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_LineChart, {
          key: 1,
          class: "users-by-belt-line-chart",
          data: _ctx.chartData,
          options: _ctx.options,
          height: 200
        }, null, 8 /* PROPS */, ["data", "options"]))
      : _createCommentVNode("v-if", true),
    _hoisted_12
  ], 64 /* STABLE_FRAGMENT */))
}